import type { TransformedToken } from 'providers/VisionRouter'

type LocationQueryMap = {
  locationId?: string
  locationIds?: string[]
}

export function getLocationIdFromQueryAndContext(
  queryMap?: LocationQueryMap | null,
  tokenContext?: TransformedToken | null,
) {
  // sets the locationId, and locationIds, the latter fallbacks to the locationId if not set
  // to keep consistency when the Location Multiselector is not enabled vía FF
  const locationId = queryMap?.locationId || tokenContext?.locationId
  const locationIds = queryMap?.locationIds?.length ? queryMap.locationIds : locationId ? [locationId] : []

  return {
    locationId,
    locationIds,
  }
}

export function getLocationIdFromQuery(queryMap?: LocationQueryMap | null) {
  const locationId = queryMap?.locationId
  const locationIds = queryMap?.locationIds?.length ? queryMap.locationIds : locationId ? [locationId] : []

  return {
    locationId,
    locationIds,
  }
}
